import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Notice the foreignness",
    opening: localizedGenderNode(
      [
      "Today I don't try to change it.",
      "I just notice the foreignness as it is.",
      "That is enough for now."
    ],
      [
      "Today I don't try to change it.",
      "I just notice the foreignness as it is.",
      "That is enough for now."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "When is the foreignness most felt?",
      "What is happening around me then?",
      "How does it feel in my body?"
    ],
      [
      "When is the foreignness most felt?",
      "What is happening around me then?",
      "How does it feel in my body?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Noticing foreignness is already a gentle connection."
    ],
      [
      "Noticing foreignness is already a gentle connection."
    ]
    ),
    action: localizedGenderNode(
      "one breath with the words \"I am here\".",
      "one breath with the words \"I am here\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "What I miss here",
    opening: localizedGenderNode(
      [
      "Today I notice what I miss here.",
      "Without comparison.",
      "Just to feel."
    ],
      [
      "Today I notice what I miss here.",
      "Without comparison.",
      "Just to feel."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe slowly.",
      "I feel my chest."
    ],
      [
      "I breathe slowly.",
      "I feel my chest."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What do I miss from the old home?",
      "What would I like to have here?",
      "What is hard for me to ask for?"
    ],
      [
      "What do I miss from the old home?",
      "What would I like to have here?",
      "What is hard for me to ask for?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small lack explains a lot."
    ],
      [
      "A small lack explains a lot."
    ]
    ),
    action: localizedGenderNode(
      "write one word about what is missing.",
      "write one word about what is missing."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "What I bring with me",
    opening: localizedGenderNode(
      [
      "Today I remember what I bring with me.",
      "Not to lose.",
      "Just to remember."
    ],
      [
      "Today I remember what I bring with me.",
      "Not to lose.",
      "Just to remember."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "One breath."
    ],
      [
      "I pause for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What one thing from home stays in me?",
      "What in me has not changed?",
      "How does it feel to remember that?"
    ],
      [
      "What one thing from home stays in me?",
      "What in me has not changed?",
      "How does it feel to remember that?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Bringing something from home is an anchor."
    ],
      [
      "Bringing something from home is an anchor."
    ]
    ),
    action: localizedGenderNode(
      "write one thing I bring with me.",
      "write one thing I bring with me."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "Small moments of belonging",
    opening: localizedGenderNode(
      [
      "Today I look for small moments of belonging.",
      "Even if brief.",
      "They exist."
    ],
      [
      "Today I look for small moments of belonging.",
      "Even if brief.",
      "They exist."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe slowly.",
      "I feel my feet."
    ],
      [
      "I breathe slowly.",
      "I feel my feet."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "When did I feel a drop of belonging here?",
      "What allowed me to feel it?",
      "How does it feel in my body?"
    ],
      [
      "When did I feel a drop of belonging here?",
      "What allowed me to feel it?",
      "How does it feel in my body?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Even a drop of belonging changes something."
    ],
      [
      "Even a drop of belonging changes something."
    ]
    ),
    action: localizedGenderNode(
      "remember one such moment.",
      "remember one such moment."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "The fear of getting it wrong here",
    opening: localizedGenderNode(
      [
      "Today I check the fear of getting it wrong.",
      "Not to fight.",
      "Just to see."
    ],
      [
      "Today I check the fear of getting it wrong.",
      "Not to fight.",
      "Just to see."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "One breath."
    ],
      [
      "I pause for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What am I afraid of here?",
      "What do I think will happen if I get it wrong?",
      "How does this fear protect me?"
    ],
      [
      "What am I afraid of here?",
      "What do I think will happen if I get it wrong?",
      "How does this fear protect me?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Fear here is also a wish to belong."
    ],
      [
      "Fear here is also a wish to belong."
    ]
    ),
    action: localizedGenderNode(
      "tell myself \"I see you\".",
      "tell myself \"I see you\"."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "A small step of visibility",
    opening: localizedGenderNode(
      [
      "Today I choose a small step of visibility.",
      "Not big.",
      "Small."
    ],
      [
      "Today I choose a small step of visibility.",
      "Not big.",
      "Small."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe.",
      "I am here."
    ],
      [
      "I breathe.",
      "I am here."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What small step can I take?",
      "What will feel safe enough?",
      "How will it protect me?"
    ],
      [
      "What small step can I take?",
      "What will feel safe enough?",
      "How will it protect me?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small step is enough to begin."
    ],
      [
      "A small step is enough to begin."
    ]
    ),
    action: localizedGenderNode(
      "choose one small step and remember it.",
      "choose one small step and remember it."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "Staying one more moment",
    opening: localizedGenderNode(
      [
      "Today I practice staying one more moment in a new place.",
      "Not running too fast.",
      "Just a moment."
    ],
      [
      "Today I practice staying one more moment in a new place.",
      "Not running too fast.",
      "Just a moment."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "One breath."
    ],
      [
      "I pause for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "When do I pull back too fast?",
      "What scares me if I stay?",
      "What happens if I stay 10 more seconds?"
    ],
      [
      "When do I pull back too fast?",
      "What scares me if I stay?",
      "What happens if I stay 10 more seconds?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "One more moment can open a door."
    ],
      [
      "One more moment can open a door."
    ]
    ),
    action: localizedGenderNode(
      "pause 10 seconds before I pull back.",
      "pause 10 seconds before I pull back."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "A small place for getting to know",
    opening: localizedGenderNode(
      [
      "Today I check a small place for getting to know.",
      "Not much.",
      "A little."
    ],
      [
      "Today I check a small place for getting to know.",
      "Not much.",
      "A little."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe slowly.",
      "I feel my heart."
    ],
      [
      "I breathe slowly.",
      "I feel my heart."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Where could I feel a little closer?",
      "What gives me safety there?",
      "What small step can I take?"
    ],
      [
      "Where could I feel a little closer?",
      "What gives me safety there?",
      "What small step can I take?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small closeness can begin here."
    ],
      [
      "A small closeness can begin here."
    ]
    ),
    action: localizedGenderNode(
      "notice a small place that feels safe.",
      "notice a small place that feels safe."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "One word in my language",
    opening: localizedGenderNode(
      [
      "Today I bring one word in my language.",
      "Like an anchor.",
      "One word."
    ],
      [
      "Today I bring one word in my language.",
      "Like an anchor.",
      "One word."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "One breath."
    ],
      [
      "I pause for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Which word brings me home?",
      "When does saying it help me?",
      "How does it feel in my body?"
    ],
      [
      "Which word brings me home?",
      "When does saying it help me?",
      "How does it feel in my body?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "One word can be a small home."
    ],
      [
      "One word can be a small home."
    ]
    ),
    action: localizedGenderNode(
      "say the word in my heart once.",
      "say the word in my heart once."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "A small request",
    opening: localizedGenderNode(
      [
      "Today I form a small request for myself.",
      "No drama.",
      "A request."
    ],
      [
      "Today I form a small request for myself.",
      "No drama.",
      "A request."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe.",
      "I am here."
    ],
      [
      "I breathe.",
      "I am here."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What would I like to happen here?",
      "How can I ask for it gently?",
      "What is a small step toward it?"
    ],
      [
      "What would I like to happen here?",
      "How can I ask for it gently?",
      "What is a small step toward it?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "One request can open a door."
    ],
      [
      "One request can open a door."
    ]
    ),
    action: localizedGenderNode(
      "write the request in one sentence.",
      "write the request in one sentence."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "A small thing that holds",
    opening: localizedGenderNode(
      [
      "Today I notice a small thing that holds me here.",
      "Even if small.",
      "That is enough."
    ],
      [
      "Today I notice a small thing that holds me here.",
      "Even if small.",
      "That is enough."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "One breath."
    ],
      [
      "I pause for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What holds me on hard days here?",
      "Who or what gives me a drop of stability?",
      "How does it feel to have something like that?"
    ],
      [
      "What holds me on hard days here?",
      "Who or what gives me a drop of stability?",
      "How does it feel to have something like that?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Something small can be an anchor."
    ],
      [
      "Something small can be an anchor."
    ]
    ),
    action: localizedGenderNode(
      "hold something that calms me for a moment.",
      "hold something that calms me for a moment."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Being with me here",
    opening: localizedGenderNode(
      [
      "Today I practice being with me even here.",
      "Not running away.",
      "Just being."
    ],
      [
      "Today I practice being with me even here.",
      "Not running away.",
      "Just being."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe slowly.",
      "I feel my feet."
    ],
      [
      "I breathe slowly.",
      "I feel my feet."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What brings me back to myself here?",
      "What takes me away from myself here?",
      "What could help me stay?"
    ],
      [
      "What brings me back to myself here?",
      "What takes me away from myself here?",
      "What could help me stay?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Being with me here is already belonging."
    ],
      [
      "Being with me here is already belonging."
    ]
    ),
    action: localizedGenderNode(
      "one breath in any unfamiliar place.",
      "one breath in any unfamiliar place."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "A small step of belonging",
    opening: localizedGenderNode(
      [
      "Today I choose a small step of belonging.",
      "No drama.",
      "A small step."
    ],
      [
      "Today I choose a small step of belonging.",
      "No drama.",
      "A small step."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "One breath."
    ],
      [
      "I pause for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What small step am I willing to try?",
      "What will feel safe enough?",
      "How will it protect me?"
    ],
      [
      "What small step am I willing to try?",
      "What will feel safe enough?",
      "How will it protect me?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small step is enough to get closer."
    ],
      [
      "A small step is enough to get closer."
    ]
    ),
    action: localizedGenderNode(
      "choose one small step and remember it.",
      "choose one small step and remember it."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Return sentence",
    opening: localizedGenderNode(
      [
      "Today I choose a sentence that brings me back to belonging.",
      "When I feel foreign.",
      "A small sentence."
    ],
      [
      "Today I choose a sentence that brings me back to belonging.",
      "When I feel foreign.",
      "A small sentence."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe.",
      "I am here."
    ],
      [
      "I breathe.",
      "I am here."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What did I learn about this foreignness?",
      "What is the first sign it returns?",
      "Which sentence brings me back a moment before?"
    ],
      [
      "What did I learn about this foreignness?",
      "What is the first sign it returns?",
      "Which sentence brings me back a moment before?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "I can feel foreign and still stay with myself."
    ],
      [
      "I can feel foreign and still stay with myself."
    ]
    ),
    action: localizedGenderNode(
      "say the new sentence once.",
      "say the new sentence once."
    ),
  },
].map(buildNormalizedDay);

export const feelingForeignInANewCountryCultureBlueprintEn = buildNormalizedPilotBlueprint({
  id: "feeling_foreign_in_a_new_country_culture_14d",
  version: "tri_locale_emit_en_v1",
  durationDays: 14,
  problemKey: "feeling_foreign_in_a_new_country_culture",
  category: "loneliness_belonging",
  journeyName: {
    he: "תחושת זרות במדינה / תרבות חדשה",
    en: "Feeling foreign in a new country / culture",
    es: "Sensación de extrañeza en un país / cultura nueva",
  },
  days,
});

export default feelingForeignInANewCountryCultureBlueprintEn;
